module.exports = __webpack_public_path__ + "static/media/20.ddc8de1c.jpg";